import template from './working-timings.html';
import controller from './working-timings.controller';

const WorkingTimingsComponent = {
  template,
  controller,
  bindings: {
    value: '<',
    enableInherit: '<',
    inherit: '=?',
    inheritLabel: '@',
    onDayChange: '&',
    readOnly: '<'
  },
};

export default WorkingTimingsComponent;



// WEBPACK FOOTER //
// ../widgets/working-timings/working-timings.component.js